import {Model} from "vue-mc";
import {Listing} from "./Listing";
import {Person} from "../Person";

export class Subscription extends Model
{
  static STATUS = {
    CREATED: "created",
    SUBSCRIBED: "subscribed",
    UNSUBSCRIBE: "unsubscribed",
    CLEANED_EMAIL: "cleanedEmail",
  }
  defaults() {
    return {
      id: null,
      listing: new Listing(),
      person: new Person(),
      status: '',
      updatedAt: '',
    }
  }
}
